export default function openSectionMenu(){
  $('body').addClass('hide-overflow');
  $('.site-wrapper').addClass('rwnav-section-side-is-open');
  $('.fs-close-button-sticky').trigger('click');

  const menuStructure = $('.rwnav-section__item').map(function(i, el){
    const $menuItem = $(el);
    const name = $menuItem.text();
    const listID = $menuItem.data('list') || null;

    if (!listID) {
      const link = $menuItem.find('a').attr('href');
      return {
        name,
        links: [{ name, link }],
      }
    }

    return {
      name, 
      links: $(`.rwnav-section-sub__group[data-list="${listID}"] .rwnav-section-sub__link`).map(function(i, el){ 
        return { name: $(el).text(), link: $(el).attr('href') }
      }).get()
    };
  }).get();

  // Take the menu structure and build the HTML for a right side navigation panel where items with a single link are just links, and items with multiple links are dropdowns
  const menuHTML = menuStructure.map(function(item){
    const { name, links } = item;
    if (links.length === 1) {
      return `
      <a href="${links[0].link}" class="rwnav-section-side-menu__group rwnav-section-side-menu__title">${name}</a>`;
    }
    
    return `<div class="rwnav-section-side-menu__group has-sub-items">
      <div class="rwnav-section-side-menu__title">${name} <i>+</i></div>
      <div class="rwnav-section-side-menu__items hide">
        ${links.map(function(item){
          return `<a href="${item.link}" class="rwnav-section-side-menu__link">${item.name}</a>`
        }).join('')}
      </div>
    </div>`;
  }).join('');

  const sectionName = $('.rwnav-section-label:first').text();

  const menuTop = `
  <div class="rwnav-section-side-menu__top">
  All ${sectionName}
  <div class="rwnav-section-side-menu__close close-section-nav">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" viewBox="0 0 24 24">
    <path d="M18 6 6 18M6 6l12 12"></path>
    </svg>
  </div>
  </div>`;

  $("body").append(`
  <div class="rwnav-section-side-menu">
    ${menuTop}
    ${menuHTML}
  </div>`);

  setTimeout(function(){ $('.rwnav-section-side-menu').addClass('is-open'); }, 0);
}
